import { Skeleton } from '#/shared/ui/skeleton'

const COLUMN_COUNT = 3

function StatSkeleton() {
  return (
    <div className="flex flex-col items-start gap-1.5">
      <Skeleton className="h-2.5 w-12" />
      <div className="flex items-center gap-1.5">
        <Skeleton className="h-6 w-20" />
        <Skeleton className="h-3 w-12" />
      </div>
    </div>
  )
}

export function MarketRateSummarySkeleton() {
  return (
    <div className="flex items-center justify-between border-b border-gray-200 bg-blue-50 px-5 py-4">
      <div className="flex items-center gap-6">
        {Array.from({ length: COLUMN_COUNT }).map((_, index) => (
          <div key={index} className="flex items-center gap-6">
            {index > 0 && (
              <span className="h-10 w-px bg-blue-100" aria-hidden />
            )}
            <StatSkeleton />
          </div>
        ))}
      </div>
    </div>
  )
}
